import { useState } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import Button from '../Button/Button';
import { triggerRefresh } from '../../Utilities/api';
import './RefreshButton.css';

/**
 * Triggers a cascading stat refresh at the given hierarchy level.
 *
 *   level: 'group' | 'account' | 'login'
 *   id:    the id at that level
 *
 * Calls onRefreshed({ newUploads, loginsRefreshed }) after the backend
 * finishes so the page can re-fetch data.
 */
const RefreshButton = ({ level, id, onRefreshed, label = 'Refresh', variant = 'secondary' }) => {
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null);

  const handleClick = async () => {
    setSpinning(true);
    setResult(null);
    try {
      const res = await triggerRefresh({ level, id });
      setResult(res);
      onRefreshed?.(res);
      setTimeout(() => setResult(null), 4000);
    } finally {
      setSpinning(false);
    }
  };

  return (
    <div className="refresh-wrap">
      <Button
        onClick={handleClick}
        disabled={spinning}
        variant={variant}
        icon={<FiRefreshCw className={spinning ? 'spin' : ''} />}
      >
        {label}
      </Button>
      {result && (
        <div className="refresh-result">
          {result.newUploads > 0
            ? `+${result.newUploads} new upload${result.newUploads === 1 ? '' : 's'}`
            : 'Up to date'}
        </div>
      )}
    </div>
  );
};

export default RefreshButton;
